import { ProductType } from "../constants";

/**
 * Determines the correct product code for rules based on the asset/instrumentation configuration.
 * Handles product variants like FWR30v10 based on extended order code.
 */
export const getProductCodeForRules = (
  productCode: string,
  extendedOrderCode?: string,
): string => {
  // Handle FWR30v10 variant based on extended order code
  if (
    productCode === ProductType.FWR30 &&
    extendedOrderCode?.charAt(5).toUpperCase() === "W" // Check for FWR30v10 device
  ) {
    return ProductType.FWR30v10;
  }
  return productCode;
};

export const isFwr30v10Device = (
  productCode: string,
  extendedOrderCode?: string,
): boolean => {
  if (
    productCode === ProductType.FWR30 &&
    extendedOrderCode?.charAt(5).toUpperCase() === "W" // Check for FWR30v10 device
  )
    return true;
  return false;
};
